import Adicionar from './Adicionar';
import Default from './Default';
import Editar from './Editar';
import Todos from './Todos';

const ComunicadosDefault = Default

export default ComunicadosDefault;
export const ComunicadosAdicionar = Adicionar;
export const ComunicadosEditar = Editar;
export const ComunicadosTodos = Todos;
